import React from "react";
import PriorityEditor from "../editors/priorityEditor";

export default class PriorityField extends React.Component {
    render() {
        let filter = null;
        if (this.props.values[this.props.componentConfig.idfield]) {
            filter = [
                {field: "option_type", value: this.props.componentConfig.componentname},
                {field: "option_id", value: this.props.values[this.props.componentConfig.idfield]},
            ];
        }
        return (
            <PriorityEditor
                filter={filter}
                presets={{
                    option_type: this.props.componentConfig.componentname,
                    option_id: this.props.values[this.props.componentConfig.idfield],
                }}
                isLoading={this.props.isLoading}
                selection={null}
            />
        );
    }
}